import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { getEntityId } from '../../api/client';
import SafeIcon from '../../common/SafeIcon';
import { getDifficulty } from '../../utils/cards';

const { FiEdit2, FiTrash2 } = FiIcons;

function WordTable({ words, onEdit, onDelete }) {
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Word</th>
            <th>Meaning</th>
            <th>Level</th>
            <th>Variant</th>
            <th className="actions-cell">Actions</th>
          </tr>
        </thead>
        <tbody>
          {words.map((word) => (
            <tr key={getEntityId(word)}>
              <td>
                <b>{word.front_text}</b>
                <small>{word.part_of_speech}</small>
              </td>
              <td className="meaning-cell">{word.back_text}</td>
              <td>
                <span
                  className={`difficulty ${getDifficulty(
                    word.target_band
                  ).toLowerCase()}`}
                >
                  {getDifficulty(word.target_band)}
                </span>
              </td>
              <td className="capitalize">{word.english_variant}</td>
              <td className="actions-cell">
                <button
                  className="icon-button"
                  onClick={() => onEdit(word)}
                  aria-label="Edit word"
                >
                  <SafeIcon icon={FiEdit2} />
                </button>
                <button
                  className="icon-button danger"
                  onClick={() => onDelete(word)}
                  aria-label="Delete word"
                >
                  <SafeIcon icon={FiTrash2} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {!words.length && (
        <div className="table-empty">No vocabulary words found.</div>
      )}
    </div>
  );
}

export default WordTable;